<template>
  <main class="main-page" style="height: 100%">
    <v-container fluid style="height: 100%">
      <v-row
          align="center"
          justify="center"
          style="height: 100%"
          v-if="isLoading"
      >
        <RingLoader color="#7ed321"/>
      </v-row>
      <div id="subscribe" v-if="!isLoading">
        <Avatar :img="img" :displayName="displayName"></Avatar>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <h2 style="color: #7ed321">ข้อมูลการสมัคร</h2>
          </v-col>
        </v-row>
        <v-form @submit.prevent="submit" ref="form" v-model="valid">
          <v-row>
            <v-col cols="12">
              <v-text-field
                  v-model="username"
                  :error-messages="usernameErrors"
                  label="กรุณาใส่ Dafabet Username"
                  required
                  solo-inverted
                  :rules="[rules.usernameRule]"
                  @input="$v.username.$touch()"
                  @blur="$v.username.$touch()"
                  :disabled="isSuccess"
                  hide-details="auto"
              ></v-text-field>
              <v-row style="margin-bottom: 5px;">
                <v-col cols="12" style="color: #7ed321; font-size: 12px"
                >Dafabet Username
                </v-col>
              </v-row>
              <span style="color: blue; padding-left: 5%"
              >*หากไม่มี Dafabet Username
                <a
                    href="https://bit.ly/37fLxwu"
                    style="color: red; text-decoration: none !important"
                >คลิกเพื่อสมัคร</a
                ></span
              >
              <br/>
              <br/>
              <v-text-field
                  v-model="firstnameTh"
                  :error-messages="firstnameThErrors"
                  label="กรุณาใส่ชื่อภาษาไทย"
                  required
                  solo-inverted
                  :rules="[rules.firstnameThRule]"
                  @input="$v.firstnameTh.$touch()"
                  @blur="$v.firstnameTh.$touch()"
                  :disabled="isSuccess"
                  hide-details="auto"
              ></v-text-field>
              <v-row style="margin-bottom: 5px;">
                <v-col cols="12" style="color: #7ed321; font-size: 12px"
                >First name (Thai)
                </v-col>
              </v-row>
              <v-text-field
                  v-model="lastnameTh"
                  :error-messages="lastnameThErrors"
                  label="กรุณาใส่นามสกุลภาษาไทย"
                  required
                  solo-inverted
                  :rules="[rules.lastnameThRule]"
                  @input="$v.lastnameTh.$touch()"
                  @blur="$v.lastnameTh.$touch()"
                  :disabled="isSuccess"
                  hide-details="auto"
              ></v-text-field>
              <v-row style="margin-bottom: 5px;">
                <v-col cols="12" style="color: #7ed321; font-size: 12px"
                >Last name (Thai)
                </v-col>
              </v-row>
              <v-text-field
                  v-model="firstnameEn"
                  :error-messages="firstnameEnErrors"
                  label="กรุณาใส่ชื่อภาษาอังกฤษ"
                  required
                  solo-inverted
                  :rules="[rules.firstnameEnRule]"
                  @input="$v.firstnameEn.$touch()"
                  @blur="$v.firstnameEn.$touch()"
                  :disabled="isSuccess"
                  hide-details="auto"
              ></v-text-field>
              <v-row style="margin-bottom: 5px;">
                <v-col cols="12" style="color: #7ed321; font-size: 12px"
                >First name (English)
                </v-col>
              </v-row>
              <v-text-field
                  v-model="lastnameEn"
                  :error-messages="lastnameEnErrors"
                  label="กรุณาใส่นามสกุลภาษาอังกฤษ"
                  required
                  solo-inverted
                  :rules="[rules.lastnameEnRule]"
                  @input="$v.lastnameEn.$touch()"
                  @blur="$v.lastnameEn.$touch()"
                  :disabled="isSuccess"
                  hide-details="auto"
              ></v-text-field>
              <v-row style="margin-bottom: 5px;">
                <v-col cols="12" style="color: #7ed321; font-size: 12px"
                >Last name (English)
                </v-col>
              </v-row>
              <span style="color: blue; padding-left: 5%"
              >*กรุณากรอกข้อมูลให้ตรงกับข้อมูลที่สมัครไว้กับ Dafabet
                หากไม่แน่ใจวิธีเช็ค
                <a
                    @click="dialog = true"
                    style="color: red; text-decoration: none !important"
                >คลิกที่นี่</a
                ></span
              >
              <br/><br/>
              <h2 style="color: #7ed321">บัญชีฝากเงิน</h2>
              <br/>
              <v-select
                  v-model="select"
                  :items="itemsBankprovider"
                  :error-messages="selectErrors"
                  label="กรุณาเลือกธนาคาร"
                  required
                  solo-inverted
                  return-object
                  @change="$v.select.$touch()"
                  @blur="$v.select.$touch()"
                  :disabled="isSuccess"
                  hide-details="auto"
              >
                <template slot="selection" slot-scope="data">
                  <img width="20px" class="mr-2" :src="data.item.logo" alt="logo"/>
                  {{ data.item.name }}
                  ({{ data.item.shortname }})
                </template>
                <template slot="item" slot-scope="data">
                  <img width="30px" class="mr-2" :src="data.item.logo" alt="logo"/>
                  {{ data.item.name }}
                  ({{ data.item.shortname }})
                </template>
              </v-select
              >
              <v-row style="margin-bottom: 5px;">
                <v-col cols="12" style="color: #7ed321; font-size: 12px"
                >Bank account
                </v-col>
              </v-row>
              <v-text-field
                  v-if="select"
                  v-model="bankAcc"
                  :error-messages="bankAccErrors"
                  :rules="[rules.bankAccRule(bankAcc, select)]"
                  label="กรุณาใส่เลขบัญชี"
                  required
                  solo-inverted
                  @input="$v.bankAcc.$touch()"
                  @blur="$v.bankAcc.$touch()"
                  :disabled="isSuccess"
                  hide-details="auto"
              ></v-text-field>
              <v-row v-if="select" style="margin-bottom: 5px;">
                <v-col cols="12" style="color: #7ed321; font-size: 12px"
                >Account number
                </v-col>
              </v-row>
              <h2 style="color: #7ed321">ยอมรับเงื่อนไข</h2>
              <v-checkbox
                  class="select"
                  v-model="checkbox"
                  :error-messages="checkboxErrors"
                  required
                  @change="$v.checkbox.$touch()"
                  @blur="$v.checkbox.$touch()"
              >
                <template v-slot:label>
                  <div>
                    สำหรับการใช้บริการ XOPay กรุณาดำเนินการ ดังนี้
                    <br/>
                    <span>
                      (1) ระบุ ชื่อ นามสกุล และบัญชีธนาคาร
                      ให้ตรงกับที่สมัครไว้ที่ Dafabet เท่านั้น
                      เพื่อความปลอดภัยของบัญชีท่านเอง</span
                    ><br/>
                    <span>(2) ฝากเงินจากบัญชีที่ลงทะเบียนไว้ในระบบเท่านั้น</span
                    ><br/>
                    <span
                    >(3) ยินยอมให้ระบบบันทึกข้อมูลที่ท่านได้ระบุไว้ทั้งหมด<br/>ระบบ
                      XOPay ขอสงวนสิทธ์ในการเปลี่ยนแปลงเงื่อนไข หรือยกเลิก
                      โดยไม่ต้องแจ้งให้ทราบล่วงหน้า</span
                    >
                  </div>
                </template>
              </v-checkbox>
              <br/>

              <v-btn
                  block
                  elevation="2"
                  x-large
                  @click="submit"
                  :style="!$v.$invalid && valid && !isSuccess ? 'background-color: #7ed321' : ''"
                  :disabled="$v.$invalid || !valid || isSuccess"
              >
                สมัคร
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </v-container>
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#7ed321" elevation="0">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>วิธีเช็ค</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row class="pa-2">
          <v-col cols="12">
            <img src="../assets/firtst.png" alt="" style="width: 100%"/>
            <img src="../assets/second.png" alt="" style="width: 100%"/>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import Avatar from "../components/Avatar";
import liff from "@line/liff";
import {RingLoader} from "vue-spinners-css";
import playerService from "../services/player_service.js";
import ttb from "../assets/TTB.jpeg";
import {bankAccountRule} from "../config/banks.js";

function sanitizeInput(value) {
  return String(value || "")
      .replace(/\u200B/g, "")
      .replace(/\u200C/g, "")
      .replace(/\u200D/g, "")
      .replace(/\uFEFF/g, "")
      .replace(/\u00A0/g, " ")
      .trim();
}

export default {
  components: {
    Avatar,
    RingLoader,
  },
  mixins: [validationMixin],
  validations: {
    username: {required},
    firstnameTh: {required},
    lastnameTh: {required},
    firstnameEn: {required},
    lastnameEn: {required},
    bankAcc: {required},
    // email: { required, email },
    select: {required},
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },
  name: "Subscribe",
  data: () => ({
    valid: true,
    errors: [],
    displayName: "",
    username: "",
    firstnameTh: "",
    lastnameTh: "",
    firstnameEn: "",
    lastnameEn: "",
    bankAcc: "",
    // email: "",
    img: "",
    select: null,
    lineId: "",
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    itemsBankprovider: [
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FSCB.png?alt=media&token=4bcea6cf-b654-47ce-a099-7ec62c95169f",
        name: "ธนาคารไทยพาณิชย์",
        shortname: "SCB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKBNK.png?alt=media&token=9a4c15d8-ef3c-43a4-bc4e-0498b1a7fa1d",
        name: "ธนาคารกสิกรไทย",
        shortname: "KBNK",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKTBA.png?alt=media&token=f48498e0-331e-484e-98a2-99880d10cb06",
        name: "ธนาคารกรุงไทย",
        shortname: "KTB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBBLA.png?alt=media&token=f563a3e0-fcdc-4135-ac8e-878fa44eeaef",
        name: "ธนาคารกรุงเทพ",
        shortname: "BBL",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBAYA.png?alt=media&token=e3c78d16-0c04-47ae-9280-867aaef46feb",
        name: "ธนาคารกรุงศรีอยุธยา",
        shortname: "BAY",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FGSBA.png?alt=media&token=c0d650ae-6748-445d-bc4f-ce8843b9706c",
        name: "ธนาคารออมสิน",
        shortname: "GSBA",
      },
      // {
      //   logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FTMBA.png?alt=media&token=210fdf60-2efe-4043-b982-55bcba748cf0",
      //   name: "ธนาคารทหารไทย",
      //   shortname: "TMBA",
      // },
      // {
      //   logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FTBNK.jpg?alt=media&token=51a47ad4-f37c-4573-b7dd-b2dc53ad4d8a",
      //   name: "ธนาคารธนชาต",
      //   shortname: "TBNK",
      // },
      {
        logo: ttb,
        name: "ธนาคารทีเอ็มบีธนชาต",
        shortname: "TMB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKKBA.png?alt=media&token=ac103755-a94a-40d4-afef-2383dcb73e89",
        name: "ธนาคารเกียรตินาคิน",
        shortname: "KKBA",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FGHBA.png?alt=media&token=4caa517e-2d35-4413-8be9-ddfb09ff88b7",
        name: "ธนาคารอาคารสงเคราะห์",
        shortname: "GHBA",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBAAC.png?alt=media&token=db135e19-2125-43bb-a4aa-a70b0977f744",
        name: "ธนาคารเพื่อการเกษตรและสหกรณ์",
        shortname: "BAAC",
      },
    ],
    checkbox: false,
    rules: {
      usernameRule: (value) => {
        const pattern = /^[a-zA-Z\-0-9]+$/;
        return pattern.test(sanitizeInput(value)) || "กรุณากรอก Username ให้ถูกต้อง";
      },
      firstnameThRule: (value) => {
        const pattern = /^[ก-๏]+$/;
        return pattern.test(sanitizeInput(value)) || "กรุณากรอก ชื่อภาษาไทย ให้ถูกต้อง";
      },
      lastnameThRule: (value) => {
        const pattern = /^[ก-๏]+$/;
        return pattern.test(sanitizeInput(value)) || "กรุณากรอก นามสกุลภาษาไทย ให้ถูกต้อง";
      },
      firstnameEnRule: (value) => {
        const pattern = /^[a-zA-Z]+$/;
        return pattern.test(sanitizeInput(value)) || "กรุณากรอก ชื่อภาษาอังกฤษ ให้ถูกต้อง";
      },
      lastnameEnRule: (value) => {
        const pattern = /^[a-zA-Z]+$/;
        return pattern.test(sanitizeInput(value)) || "กรุณากรอก นามสกุลภาษาอังกฤษ ให้ถูกต้อง";
      },
      bankAccRule: (value, select) =>
          bankAccountRule(sanitizeInput(value), select),
    },
    isLoading: false,
    isSuccess: false,
    errorMsg: "",
    dialog: false,
    isVerify: true,
    dialogConfirm: false,
    messageConfirm: "",
  }),
  computed: {
    checkboxErrors() {
      const errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      !this.$v.checkbox.checked &&
      errors.push("คุณต้องยอมรับเงื่อนไขเพื่อดำเนินการต่อ!");
      return errors;
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      !this.$v.select.required && errors.push("กรุณาเลือกธนาคาร");
      return errors;
    },
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.required && errors.push("กรุณาใส่ Username");
      return errors;
    },
    firstnameThErrors() {
      const errors = [];
      if (!this.$v.firstnameTh.$dirty) return errors;
      !this.$v.firstnameTh.required && errors.push("กรุณาใส่ชื่อภาษาไทย");
      return errors;
    },
    lastnameThErrors() {
      const errors = [];
      if (!this.$v.lastnameTh.$dirty) return errors;
      !this.$v.lastnameTh.required && errors.push("กรุณาใส่นามสกุลภาษาไทย");
      return errors;
    },
    firstnameEnErrors() {
      const errors = [];
      if (!this.$v.firstnameEn.$dirty) return errors;
      !this.$v.firstnameEn.required && errors.push("กรุณาใส่ชื่อภาษาอังกฤษ");
      return errors;
    },
    lastnameEnErrors() {
      const errors = [];
      if (!this.$v.lastnameEn.$dirty) return errors;
      !this.$v.lastnameEn.required && errors.push("กรุณาใส่นามสกุลภาษาอังกฤษ");
      return errors;
    },
    bankAccErrors() {
      const errors = [];
      if (!this.$v.bankAcc.$dirty) return errors;
      !this.$v.bankAcc.required && errors.push("กรุณาใส่เลขบัญชี");
      return errors;
    },
  },
  created() {
    this.getLineLiff();
  },
  methods: {
    getLineLiff() {
      liff
          .init({
            liffId: "1657076095-6glrowkK", // prod
            // liffId: "1657078715-18BnkoZy", //local
          })
          .then(async () => {
            if (liff.isLoggedIn()) {
              let getProfile = await liff.getProfile();
              this.displayName = getProfile.displayName;
              this.img = getProfile.pictureUrl;
              this.lineId = getProfile.userId;
            } else {
              liff.login();
            }
          })
          .catch((err) => {
            // Error happens during initialization
            console.log(err.code, err.message);
            this.$toast.error(
                "ไม่สามารถดึงข้อมูล LINE ได้ กรุณาปิดหน้านี้แล้วเปิดใหม่ผ่านแอป LINE อีกครั้ง",
                {
                  position: "top-center",
                  timeout: 5000,
                  closeOnClick: true,
                  pauseOnFocusLoss: true,
                  pauseOnHover: true,
                  draggable: true,
                  draggablePercent: 0.6,
                  showCloseButtonOnHover: false,
                  hideProgressBar: false,
                  closeButton: "button",
                  icon: true,
                  rtl: false,
                }
            );
          });
    },
    submit() {
      this.$v.$touch();
      const isFormValid = this.$refs.form.validate();
      console.log(this.valid);
      if (this.$v.$invalid || !isFormValid) {
        // this.submitStatus = "ERROR";
        return;
      } else {
        if (!this.lineId) {
          this.$toast.error(
              "ไม่สามารถดึงข้อมูล LINE ได้ กรุณาปิดหน้านี้แล้วเปิดใหม่ผ่านแอป LINE อีกครั้ง",
              {
                position: "top-center",
                timeout: 5000,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false,
              }
          );
          return;
        }
        this.isVerify = true;
        this.isLoading = true;
        if (this.isVerify) {
          let body = {
            username: sanitizeInput(this.username),
            bankName: this.select.shortname,
            accountNo: sanitizeInput(this.bankAcc),
            accountName: sanitizeInput(this.firstnameEn),
            accountSurname: sanitizeInput(this.lastnameEn),
            accountNameTh: sanitizeInput(this.firstnameTh),
            accountSurnameTh: sanitizeInput(this.lastnameTh),
            lineId: this.lineId,
          };
          playerService
              .postPlayer(body)
              .then((res) => {
                this.isLoading = false;
                this.isSuccess = true;
                this.$toast.success(res.data.message, {
                  position: "top-center",
                  timeout: 5000,
                  closeOnClick: true,
                  pauseOnFocusLoss: true,
                  pauseOnHover: true,
                  draggable: true,
                  draggablePercent: 0.6,
                  showCloseButtonOnHover: false,
                  hideProgressBar: false,
                  closeButton: "button",
                  icon: true,
                  rtl: false,
                });
                setTimeout(() => {
                  liff.closeWindow();
                }, 3000);
              })
              .catch((error) => {
                this.isLoading = false;
                console.log(error);
                const msg =
                    (error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.display_message) ||
                    "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
                this.$toast.error(msg, {
                  position: "top-center",
                  timeout: 5000,
                  closeOnClick: true,
                  pauseOnFocusLoss: true,
                  pauseOnHover: true,
                  draggable: true,
                  draggablePercent: 0.6,
                  showCloseButtonOnHover: false,
                  hideProgressBar: false,
                  closeButton: "button",
                  icon: true,
                  rtl: false,
                });
                this.errored = true;
              });
        }
      }
    },
    clear() {
      this.$v.$reset();
      this.username = "";
      this.firstnameTh = "";
      this.lastnameTh = "";
      this.firstnameEn = "";
      this.lastnameEn = "";
      this.bankAcc = "";
      this.select = null;
      this.checkbox = false;
    },
  },
};
</script>

<style>
.select .v-input__slot {
  align-items: flex-start !important;
}
</style>
